import React from 'react';

import { Section, preloader } from 'spectacle-ppa';

import headingSlide from '../../baseSlides/headingSlide';
import balloonSlide from '../../baseSlides/balloonSlide';
import videoSlide from '../../baseSlides/videoSlide';

import imagePPALogo from '../../images/logo_ppa.png';
import esPowerStance from '../../images/characters/esPowerStance.png';
import esHandsOutWehey from '../../images/characters/esmeralda_hands_out_wehey.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel1 from './level1_operationGarbageWatch.md';
import markdownFileLevel2 from './level2_operationLoveFoodHateWaste.md';
import markdownFileLevel3 from './level3_operationFoodScraps.md';
import markdownFileLevel4 from './level4_operationWasteFreeLunch.md';
import markdownFileLevel5 from './level5_operationBuySmart.md';

const levels = {
  '1': { md: new MarkdownScript(markdownFileLevel1) },
  '2': { md: new MarkdownScript(markdownFileLevel2) },
  '3': { md: new MarkdownScript(markdownFileLevel3) },
  '4': { md: new MarkdownScript(markdownFileLevel4) },
  '5': { md: new MarkdownScript(markdownFileLevel5) }
};

export function preloadMissionAssignment () {
  preloader([
    imagePPALogo,
    esPowerStance,
    esHandsOutWehey
  ]);
}

function missionAssignmentSection ({ level, title, regionData }) {
  const md = levels[level].md;
  return (
    <Section id="mission-assignment">

      {/* Mission assignment intro only in levels 3 & 5 */}
      { (level === 3 || level === 5) &&
        videoSlide({
          id: 'intro-video',
          notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
          youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
        })
      }

      {/* Sizzle */}
      {headingSlide({
        id: 'sizzle',
        beforeImage: imagePPALogo,
        subHeading: `Mission ${level}:<br/> ${title}`,
        notes: md.getSubSectionAsHtml('Mission Assignment', 'Notes', false, regionData),
        bgColor: 'black'
      })}

      {/* Mission Instructions levels 1,3 & 5 */}
      { (level === 1 || level === 3 || level === 5) &&
        balloonSlide({
          id: 'instructions',
          characterSide: 'right',
          characterImage: esPowerStance,
          notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
          html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
        })
      }

      {/* Bonus mission in level 1 */}
      { (level === 1) &&
        balloonSlide({
          id: 'bonus-mission',
          characterSide: 'right',
          characterImage: esHandsOutWehey,
          notes: md.getSubSectionAsHtml('Bonus Mission', 'Notes', false, regionData),
          html: md.getSubSectionAsHtml('Bonus Mission', 'Content', false, regionData)
        })
      }

      {/* Mission Instructions levels 2 & 4 */}
      { (level === 2 || level === 4) &&
        balloonSlide({
          id: 'instructions',
          characterSide: 'right',
          characterImage: esHandsOutWehey,
          notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
          html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
        })
      }

      {/* Mission assignment outro only in level 1 */}
      { (level === 1) &&
        videoSlide({
          id: 'outro',
          notes: md.getSubSectionAsHtml('Outro Video', 'Notes', false, regionData),
          youTubeId: md.getSectionMetadata('Outro Video', 'YouTube', regionData)
        })
      }

    </Section>
  );
}

export default missionAssignmentSection;



// WEBPACK FOOTER //
// ./programs/zeroHeroes/sections/70_missionAssignment/missionAssignmentSection.jsx